export const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-background text-foreground">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Company:</strong> Realise Property Maintenance Ltd. trading as "Sortable"
        </p>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>Telephone:</strong> 08000438880
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
          <p className="mb-3">
            This Privacy Policy explains how Realise Property Maintenance Ltd. ("we," "us," or "our") 
            collects, uses, and protects your personal information when you use the Sortable platform.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Information We Collect</h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium mb-2">2.1. Personal Information</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Name and contact details (email, phone number, address)</li>
                <li>Account credentials and profile information</li>
                <li>Payment information (processed securely through third-party providers)</li>
                <li>Professional qualifications and certifications (for tradespeople)</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium mb-2">2.2. Technical Information</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>IP address and browser information</li>
                <li>Device type and operating system</li>
                <li>Usage data and platform interactions</li>
                <li>Location data (with your consent)</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. How We Use Your Information</h2>
          <div className="space-y-2">
            <p>3.1. To provide and improve our services</p>
            <p>3.2. To facilitate connections between customers and tradespeople</p>
            <p>3.3. To process payments and manage accounts</p>
            <p>3.4. To communicate with you about our services</p>
            <p>3.5. To comply with legal obligations</p>
            <p>3.6. To prevent fraud and ensure platform security</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Legal Basis for Processing</h2>
          <div className="space-y-2">
            <p>4.1. <strong>Contract:</strong> Processing necessary for our service agreement</p>
            <p>4.2. <strong>Legitimate Interest:</strong> Platform improvement and fraud prevention</p>
            <p>4.3. <strong>Consent:</strong> Marketing communications and location data</p>
            <p>4.4. <strong>Legal Obligation:</strong> Compliance with applicable laws</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Information Sharing</h2>
          <div className="space-y-2">
            <p>5.1. We share information between customers and tradespeople to facilitate services</p>
            <p>5.2. We may share data with trusted service providers (payment processors, hosting services)</p>
            <p>5.3. We may disclose information if required by law or to protect our rights</p>
            <p>5.4. We do not sell your personal information to third parties</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Data Security</h2>
          <p className="mb-3">
            We implement appropriate technical and organizational measures to protect your personal 
            information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Data Retention</h2>
          <p className="mb-3">
            We retain your personal information for as long as necessary to provide our services 
            and comply with legal obligations. Account data is typically retained for 7 years after 
            account closure for business and legal purposes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Your Rights (GDPR)</h2>
          <div className="space-y-2">
            <p>8.1. <strong>Access:</strong> Request copies of your personal information</p>
            <p>8.2. <strong>Rectification:</strong> Request correction of inaccurate information</p>
            <p>8.3. <strong>Erasure:</strong> Request deletion of your personal information</p>
            <p>8.4. <strong>Portability:</strong> Request transfer of your data</p>
            <p>8.5. <strong>Objection:</strong> Object to processing based on legitimate interests</p>
            <p>8.6. <strong>Restriction:</strong> Request limitation of processing</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Cookies</h2>
          <p className="mb-3">
            We use cookies and similar technologies to improve user experience, analyze usage, 
            and provide personalized content. You can manage cookie preferences through your browser settings.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Contact Information</h2>
          <div className="space-y-2">
            <p>For privacy-related inquiries, please contact us:</p>
            <p><strong>Data Protection Officer:</strong> privacy@sortable.co.uk</p>
            <p><strong>Phone:</strong> 08000438880</p>
            <p><strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">11. Changes to This Policy</h2>
          <p className="mb-3">
            We may update this Privacy Policy from time to time. We will notify you of any 
            significant changes by posting the new policy on our platform and updating the 
            "Last Updated" date.
          </p>
        </section>
      </div>
    </div>
  );
};